module.exports = "/images/box.svg?8582a8837b668546a29fe77e858e129e";